import Backend from "ln/backend/Backend";

export var backend = new Backend();